import { ERROR_CODES } from "./app-error";

export const EXPECTED_ERROR_CODES: ReadonlySet<string> = new Set<string>([
  ERROR_CODES.AUTH_REQUIRED,
  ERROR_CODES.FORBIDDEN,
  ERROR_CODES.VALIDATION_FAILED,
  ERROR_CODES.BILLING_REQUIRED,
  ERROR_CODES.NOT_FOUND,
  ERROR_CODES.CONFLICT,
  ERROR_CODES.INVALID_STATE,
  ERROR_CODES.CONFIRMATION_REQUIRED,
  ERROR_CODES.SETTLEMENT_CHOICE_REQUIRED,
  ERROR_CODES.DUPLICATE,
  ERROR_CODES.EXPIRED,
  ERROR_CODES.RATE_LIMIT,
  ERROR_CODES.QUOTA_EXCEEDED,
]);

const EXPECTED_CONVEX_ERROR_ENVELOPE = String.raw`(?:Uncaught\s+)?ConvexError:\s*\{\s*\\?"code\\?"\s*:\s*\\?"(?:${[...EXPECTED_ERROR_CODES].join("|")})\\?"`;

export const EXPECTED_CONVEX_ERROR_PATTERN = `^${EXPECTED_CONVEX_ERROR_ENVELOPE}`;
export const EXPECTED_CONVEX_LOG_ERROR_PATTERN = String.raw`"error_message"\s*:\s*"${EXPECTED_CONVEX_ERROR_ENVELOPE}`;

export const MISSING_PUBLIC_FUNCTION_MESSAGE = "Could not find public function";
